import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assests/css/teachers/TeacherLogin.css";
import loginImg from "../../../assests/Images/tt.jpg";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";

const TeacherLogin = () => {
  const [loginLoading, setLoginLoading] = useState(false);

  const { baseUrl, setLoggedInTeacher } = useContext(AppContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

// NEW: device info states
  const [osVersion, setOsVersion] = useState("");
  const [deviceModel, setDeviceModel] = useState("");
  // NEW: detect OS version and device model from browser userAgent
  const detectDeviceInfo = () => {
    const ua = navigator.userAgent;
    let detectedOs = "Unknown OS";
    let detectedModel = ua; // fallback: full user-agent string

    if (/Windows NT 10/.test(ua)) detectedOs = "Windows 10/11";
    else if (/Windows NT/.test(ua)) detectedOs = "Windows";
    else if (/Mac OS X (\d+[_\.]\d+)/.test(ua))
      detectedOs =
        "macOS " + ua.match(/Mac OS X (\d+[_\.]\d+)/)[1].replace("_", ".");
    else if (/Android (\d+(\.\d+)?)/.test(ua))
      detectedOs = "Android " + ua.match(/Android (\d+(\.\d+)?)/)[1];
    else if (/iPhone OS (\d+[_\.]\d+)/.test(ua))
      detectedOs =
        "iOS " + ua.match(/iPhone OS (\d+[_\.]\d+)/)[1].replace("_", ".");
    else if (/Linux/.test(ua)) detectedOs = "Linux";

    const modelMatch = ua.match(/\(([^)]+)\)/);
    if (modelMatch) detectedModel = modelMatch[1];

    setOsVersion(detectedOs);
    setDeviceModel(detectedModel);
  };

  // NEW: run detection once when component mounts
  useEffect(() => {
    detectDeviceInfo();
  }, []);

  const teacherLogin = (e) => {
    console.log("Login function called", email, password);
    e.preventDefault();

    setLoginLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("os_version", osVersion); // NEW
    formData.append("device_model", deviceModel); // NEW

    axios
      .post(`${baseUrl}/teacher/auth/teacherLogin`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);

        if (response.data.success === true) {
          // Teacher Data Save
          localStorage.setItem("teacherEmail", response.data.teacher.email);
          localStorage.setItem(
            "teacherPassword",
            response.data.teacher.password,
          );
          localStorage.setItem(
            "teacher",
            JSON.stringify(response.data.teacher),
          );
          setLoggedInTeacher(response.data.teacher);
          setEmail("");
          setPassword("");

          navigate("/teacher/dashboard");
        } else {
          Swal.fire({
            icon: "error",
            title: "Does not match",
            text: "Invalid email and password",
          });
        }

        setLoginLoading(false);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "does not match",
          text: "invalid email and password  ",
        });

        setLoginLoading(false);
      });
  };

  const autoLogin = (savedTeacher) => {
    setLoginLoading(true);

    const formData = new FormData();
    formData.append("email", savedTeacher.email);
    formData.append("password", savedTeacher.password);
    formData.append("os_version", osVersion); // NEW
    formData.append("device_model", deviceModel); // NEW

    axios
      .post(`${baseUrl}/teacher/auth/teacherLogin`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);

        if (response.data.success === true) {
          // Teacher Data Save
          setLoggedInTeacher(response.data.teacher);

          navigate("/teacher/dashboard");
        } else {
          Swal.fire({
            icon: "error",
            title: "does not match",
            text: "invalid email and password ",
          });
        }

        setLoginLoading(false);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "does not match",
          text: "invalid email and password  ",
        });

        setLoginLoading(false);
      });
  };

  useEffect(() => {
    const savedTeacher = JSON.parse(localStorage.getItem("teacher"));
    if (savedTeacher) {
      autoLogin(savedTeacher);
    }
  }, []);
  

  return (
    <>
      {loginLoading ? (
        <div className="spinner-class">
          <ClipLoader
            color="black"
            loading={loginLoading}
            size={50}
            aria-label="Loading Spinner"
          />
        </div>
      ) : (
        <div className="tp-login-wrapper">
          <div className="tp-login-card">
            {/* LEFT FORM */}
            <div className="tp-login-form">
              <h2 className="tp-login-title">Teacher Login</h2>

              <p className="tp-login-subtitle">
                Login to manage your classes & results
              </p>

              <form>
                <input
                  type="email"
                  placeholder="Email Address"
                  className="tp-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <input
                  type="password"
                  placeholder="Password"
                  className="tp-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                {/* NEW: visible device info shown to teacher */}
                <p
                  className="tp-device-info"
                  style={{ fontSize: "12px", color: "#777", margin: "8px 0" }}
                >
                  Device: {deviceModel} | OS: {osVersion}
                </p>

                <button
                  type="button"
                  className="tp-login-btn"
                  disabled={loginLoading}
                  onClick={teacherLogin}
                >
                  {loginLoading ? "LOGGING IN..." : "LOGIN"}
                </button>
              </form>
            </div>

            {/* RIGHT IMAGE */}
            <div className="tp-login-image">
              <img src={loginImg} alt="Teacher Login Illustration" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TeacherLogin;